import script from "./Profile.vue?vue&type=script&setup=true&lang=js"
export * from "./Profile.vue?vue&type=script&setup=true&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=43d5d4c8&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Nakhoncity\\Nakhoncity-App-Queue-Idcard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43d5d4c8"]])

export default __exports__